exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ai-docs {\n  list-style: none;\n  padding: 0;\n  row-gap: 1rem;\n}", ""]);

// exports
